<template>
  <div class="editorCampaign-lifestyle">
    <div class="editorCampaign-lifestyle__summary-section" v-if="isSummary"  >
      <div class="editorCampaign-lifestyle__summary-section__container">  
        <h1 class="subhead title">Campaign Channel Name</h1>
        <div class="editorCampaign-lifestyle__summary-section__container__item">
          <adx-input :label="`Campaign Name`" :value.sync="model.name" :inputId="`campaign_name`"
            :error.sync="vuelidateOptions.name.error" :ref="vuelidateOptions.name.ref"/>
        </div>
      </div>
      <div class="editorCampaign-lifestyle__summary-section__container">  
        <h1 class="subhead title">Campaign Setting</h1>
        <div class="editorCampaign-lifestyle__summary-section__container__item">
          <div class="periodWrapper">
            <adx-select-dropdown :label="`Campaign Period`" :value.sync='model.selectedPeriod' :options="periodOptions" 
            @selected='updateEndDate($event, model)' :key="periodKey"/>
              </div>
          <div class="calendarWrapper">
            <div class="editorCampaign-lifestyle__summary-section__container__item date">
              <div :class="'calendar'">
                <v-date-picker
                  v-model='model.startDate'
                  :popoverVisibility="`focus`"
                  :min-date="minDate(model.startDate)"
                  :theme-styles='themeStyles'
                  :disabled-dates='model.startDate'
                  class='date-picker'>
                  <div class="field" slot-scope='{ inputValue, updateValue }'>
                  <div class="start_date">
                    <label class="mini-font calendar-label">Start Date</label>
                    <input
                      class="date-picker-input"
                      type='text'
                      required
                      readonly
                      :value='new Date(model.startDate)? displayDate(new Date(model.startDate)): `Unset`'
                      @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                      @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'/>
                  </div>
                  </div>
                </v-date-picker>
                <div class="arrow">
                  <i class="icon-arrow-forward"></i>
                </div>
                  <div class="date-picker">
                    <div class="field">
                      <div class="end_date">
                        <label class="mini-font calendar-label">End Date</label>
                        <input
                          class="date-picker-input color-grey"
                          type='text'
                          readonly
                          :value='new Date(model.startDate)? getEndDate(): `Unset`'
                          @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                          @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
       <div class="editorCampaign-lifestyle__summary-section__container">
          <h1 class="subhead title"> Campaign Item(s)</h1>
          <div v-for="(media, ind) in model.campaignMedias" :key="ind+`media_detail`" >
            <div v-for="(item, index) in media.line_item_list" :key="index+`item_detail`">
              <div class="editorCampaign-lifestyle__summary-section__container__item">
                <div class="campaign-item">
                  <div class="campaign-item__left">
                    <span class="subhead strong">{{item.line_item.name}}</span>
                    <span class="subhead">{{item.line_item.location_data.name}}</span>
                  </div>
                  <div class="campaign-item__right">
                    <div class="campaign-item__right__price">
                      <span class="mini-font color-grey">Price</span>
                      <span class="subhead color-pink strong">{{item.item_price | formatMoney}}</span>
                    </div>
                    <div class="icon-wrapper"> 
                      <i @click="deleteItemAvail(model.campaignMedias, ind, media.line_item_list, index)" class="icon-deleted"></i> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="line-wrapper">
            <hr class="line" />
          </div>
          <div class="addNewButton">
            <button @click="addNewLineItem" class="color-red">Add new</button>
          </div>
        </div>
    </div>
    
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api"
import lib from "@/lib/util"
import { apiV2 } from "@/api/urls"
import { helpers } from "@/lib/validation/"
import { mapGetters } from "vuex"
import { restEdge } from "@/api/edgeUrls"
import { globalMixins } from "@/lib/mixins/globalMixins"
import { required, minLength } from 'vuelidate/lib/validators'
import { ACheckbox, AInput, ATextArea, ASelectDropdown, AModal, ALoadingSecondary, AListDropdown,
        ALoadingSecondaryWhite, ASingleSearchDropdown, ALoadingPrimary, AEmptySelection, APagination} from "ui-kit-v1"
import moment from "moment";

export default {
  name: "lifestyle-campaign-editor",
  components: {
    "adx-loading": ALoadingPrimary,
    "adx-loading-2": ALoadingSecondary,
    "adx-loading-white": ALoadingSecondaryWhite,
    "adx-pagination": APagination,
    "adx-dropdown-sort": ASelectDropdown,
    "adx-dropdown-list": AListDropdown,
    "adx-single-search-dropdown": ASingleSearchDropdown,
    "adx-input": AInput,
    "adx-select-dropdown": ASelectDropdown,
    "adx-modal": AModal,
    "adx-empty-selection": AEmptySelection,
  },
  mixins: [globalMixins],
  props: {
    campaignData: {
      required: false
    },
    isSummary: {
      required: false
    },

  },
  data() {
    return {
      id: null,
      channelName: null,
      item: [],
      periodKey: 0,
      quotation: 1,
      isShowModal: false,
      isEditor: true,
      isLoading: false,
      isLoadingForm: false,
      isLoadingSave: false,
      popoverVisibility: `focus`,
      model: {
        name: null,
        selectedPeriod: 1,
        minPeriode: 1,
        subTotalPrice: 0,
        items: [],
        campaignMedias: [],
        startDate: null,
        endDate: null,
      },
      periodOptions: [],
      placementOptions: [], 
      fullPlacementOptions: [],
      vuelidateOptions: {
        name: {
          field: 'campaign name',
          error: null,
          ref: 'name'
        },
        serviceFee: {
          field: 'service fee',
          error: null,
          ref: 'serviceFee'
        }
      },
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
    };
  },
  validations: {
    model: {
      name: { required, minLength: minLength(3) },
    },
  },
  computed: {
    ...mapGetters({
      token: "token",
      isSuperuser: "isSuperuser"
    }),
  },
  watch: {
    'model.name':function(){
      this.$emit('updateSummary', {campaignName: this.model.name})
    }
  },
  apollo: {

  },
  beforeCreate() {

  },
  async created() {
  
  },
  async beforeMount() {

  },
  async mounted() {
    await this.getPeriod()
    this.mapCampaignData(this.campaignData)
  },

  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {
    
  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    mapCampaignData(data){
      this.channelName = data.channel_name
      this.model.name = data.name
      this.model.id = data.id
      this.model.subTotalPrice = data.total_price
      this.model.owner = data.owner
      this.model.startDate =this.displayDate(data.start)
      this.model.endDate = this.displayDate(data.end)
      this.model.selectedPeriod = data.campaign_medias[0].period
      this.model.campaignMedias = data.campaign_medias

      // get minimum periode
      let period = []
      data.campaign_medias.map( media =>{
        media.line_item_list.map(item =>{
          period.push(item.line_item.min_period)
        })
      })
      if (period.length > 0) this.model.minPeriode = Math.min.apply(Math,period) 
      this.getTotalItemAndPrice(this.model.campaignMedias, this.model.selectedPeriod)
      this.$emit('updateSummary', { campaignPeriod : this.model.selectedPeriod })
    },
    updateEndDate(selected, data){
      let period = 0

      if (selected) {
        if (this.model.minPeriode <= selected.item.value) {
          period = selected.item.value
        } else {
          period = this.model.minPeriode
          this.showNotificationAlert("Error", "minimum period for this media is " + this.model.minPeriode + " month(s)", "danger");
          this.model.selectedPeriod = this.model.minPeriode
          this.periodKey += 1;
        }
        
      } else {
        period = this.model.minPeriode
      }

      let end = new Date(data.startDate);
      end.setDate(end.getDate() - 1)
      end.setMonth(end.getMonth() + period);
      this.model.endDate = end
      this.getTotalItemAndPrice(this.model.campaignMedias, period)
      this.$emit('updateSummary', { campaignPeriod : period })
    },
    getEndDate(){
      var end = null
      end = new Date(this.model.startDate);
      end.setDate(end.getDate() - 1)
      end.setMonth(end.getMonth() + this.model.selectedPeriod);
      this.$emit('updateSummary', {
        campaignStart: this.displayDate(this.model.startDate), 
        campaignEnd: this.displayDate(end)
      })
      return this.displayDate(end)
    },
    deleteItemAvail(media, ind, item, index){
      let item_id = item[index].id
      if (item.length == 1) {
        this.showNotificationAlert(
            "Error", 
            "Can't delete placement, Minimum 1 placement for 1 campaign",
            "danger");
      } else {
        item.splice(index, 1);
      }
      this.getTotalItemAndPrice(media)
    },
    getTotalItemAndPrice(campaignMedias, campaignPeriod){
      let totalItem = 0
      let totalPrice = 0
      for (let media of campaignMedias) {
        totalItem += media.line_item_list.length
        for (let item of media.line_item_list) {
          campaignPeriod 
            ? totalPrice += item.price
            : totalPrice += item.price * media.period
        }
      }
      totalPrice = campaignPeriod >= this.model.minPeriode
          ? totalPrice * (campaignPeriod / this.model.minPeriode) 
          : totalPrice
      this.$emit('updateSummary', {itemCount: totalItem, subTotalPrice: totalPrice})
    },
    addNewLineItem(){
      this.$emit('addNewLineItem', {isShowModal: true});
    },
    minDate(item) {
      var date = new Date();
      date.setDate(date.getDate() + 3);
      return date
    },
    getPeriod() {
      let file = `/static/data/monthly_period.json`;
      (async () => {
        let request = await fetch(new Request(file))
        let data = await request.json()
        this.periodOptions = data.periods
      })();
    },
    displayDate(date){
      return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', new Date(date))}`
    },
    validateCampaign(isCreateQuotation){
      this.model.serviceFee = this.model.serviceFee? this.model.serviceFee : 0
      this.$v.$touch()
      if (this.$v.model.$invalid) {
        this.vuelidateHelper(this.vuelidateOptions)
      } else {
        if (isCreateQuotation) {
          this.toggleModalQuotation()
          
        } else {
          this.saveToDraft(false)
        }
      }
    },
    vuelidateHelper(vuelidateOptions){
      const { key, message, element, collection } = helpers.vuelidateValidationHelper(this.$v.model, vuelidateOptions, this.$refs)

      if (collection) {
        vuelidateOptions[key].error[collection.index][collection.collectionKey] = message
      } else {
        vuelidateOptions[key].error = message
      }
      if (typeof element[0] == "undefined") {
        this.$nextTick(function() {
          element.scrollIntoView();
        });
      } else {
        this.$nextTick(function() {
          if (element[0].hasOwnProperty("$el")) {
            element[0].$el.scrollIntoView();
          } else {
            element[0].scrollIntoView();
          }
        });
      }
      this.saveLoading = false
    },
  }
};
</script>

<style lang='scss' scoped>
@import "./index.scss";
</style>
<style lang='scss'>
.editorCampaign-lifestyle__summary-section__container__item{
  .periodWrapper{
    .selectDropdown .select input{
      min-height: 63px;
    }
  }
}
</style>